module.exports = __webpack_public_path__ + "static/media/reels.3ba884e3.png";